"use client";

import { Button } from "@frontend/shared/components/ui/button";
import { motion } from "framer-motion";
import Image from "next/image";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import {
  useInsuranceConnectorSend,
  useInsuranceConnectorState,
} from "../insurance-connector-provider";

interface AllProvidersOonResultProps {
  isMobile?: boolean;
}

export const AllProvidersOonResult = ({
  isMobile = false,
}: AllProvidersOonResultProps) => {
  const state = useInsuranceConnectorState();
  const send = useInsuranceConnectorSend();
  const t = useTranslations("InsuranceConnector");

  const orgName = state.context.orgName || t("ThisPractice");

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className={`rounded-3xl ${isMobile ? "w-full p-4" : "w-96 p-6"}`}
    >
      <div className="flex flex-col gap-4">
        <Image
          src="/images/kiosk/ActiveOON.svg"
          alt={t("OutOfNetworkAlt")}
          width={50}
          height={24}
        />
        <p className="text-2xl font-semibold">
          {t("AllProvidersOonMessage", { orgName })}
        </p>
        <p className="text-lg">{t("WhatWouldYouLikeToDo")}</p>
        <div className="flex flex-col gap-2">
          <Button
            onClick={() => send({ type: "CONTINUE_WITHOUT_INSURANCE" })}
            variant="outline"
            className="h-12 w-full rounded-full text-md hover:cursor-pointer"
          >
            {t("ContinueWithSelfPay")}
          </Button>
          <Button
            onClick={() => send({ type: "TRY_ANOTHER" })}
            className="h-12 w-full rounded-full text-md hover:cursor-pointer"
          >
            {t("TryDifferentInsurance")}
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
